import ChatWidget from "../components/chat/ChatWidget";
import { useChatNotification } from "../contexts/ChatNotificationContext";

const MessagesPage = () => {
  const { setChatUnread } = useChatNotification();
  return (
    <section className="mx-auto w-full max-w-6xl py-10">
      <ChatWidget variant="panel" onUnreadChange={setChatUnread} />
    </section>
  );
};

export default MessagesPage;
